import React from 'react';
import {
  Card,
  Container,
  Row,
  Col,
  Button,
  HeaderText,
  BodyText,
} from 'shared-portal-component';

interface AuthEmailSentProps {
  onProceed: () => void;
}

const AuthEmailSent: React.FC<AuthEmailSentProps> = ({ onProceed }) => (
  <Container fluid>
    <Card>
      <Row spacing="md">
        <Col size={12}>
          <HeaderText text='Email Sent!' className="header-text-auth" />
          <BodyText as="p" className='body-text-auth'>
            We've sent a recovery email to you. Once you have received this email, please click <b>Proceed</b>,
            or use the URL from the email, to begin the credential reset process.
          </BodyText>
        </Col>
      </Row>
      <Row spacing="md" justify='center' className="text-center">
        <Col size={12} className="flex flex-col items-center justify-center gap-4">
          <Button
            text="Proceed"
            size="md"
            type="button"
            className="w-40 mb-5"
            onClick={onProceed}
          />
        </Col>
      </Row>
    </Card>
  </Container>
);

export default AuthEmailSent;
